import { render } from "./ViolationsView.vue?vue&type=template&id=50fb5528"
import script from "./ViolationsView.vue?vue&type=script&lang=js"
export * from "./ViolationsView.vue?vue&type=script&lang=js"

import "./ViolationsView.vue?vue&type=style&index=0&id=50fb5528&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__